import { Level } from "./Level";
var Log = /** @class */ (function () {
    function Log(config) {
        this.level = Level.All;
        this.contextDecorator = function (context) { return context; };
        this.adapter = config.adapter;
        this.doAppendLogId = config.doAppendLogId !== false;
        if (config.level !== undefined) {
            this.level = config.level;
        }
        if (config.contextDecorator) {
            this.contextDecorator = config.contextDecorator;
        }
    }
    /**
     * Public logging methods
     */
    Log.prototype.emergency = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Emergency, msgs);
    };
    Log.prototype.alert = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Alert, msgs);
    };
    Log.prototype.critical = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Critical, msgs);
    };
    Log.prototype.error = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Error, msgs);
    };
    Log.prototype.warning = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Warning, msgs);
    };
    Log.prototype.warn = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.warning.apply(this, msgs);
    };
    Log.prototype.notice = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Notice, msgs);
    };
    Log.prototype.info = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Info, msgs);
    };
    Log.prototype.debug = function () {
        var msgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msgs[_i] = arguments[_i];
        }
        return this.log(Level.Debug, msgs);
    };
    Log.prototype.log = function (msgLevel, msgs) {
        if (this.level & msgLevel) {
            var msgId = this.genMsgId();
            var context = this.contextDecorator({
                _id: msgId,
            });
            var finalMsgs = this.prepareMsg(msgs, context);
            this.adapter.log(finalMsgs, msgLevel);
            return msgId;
        }
        return null;
    };
    Log.prototype.genMsgId = function () {
        return String(Date.now() + Math.floor(Math.random() * 9999 + 1));
    };
    Log.prototype.prepareMsg = function (msgs, context) {
        msgs.map(function (msg) {
            return typeof msg !== "string"
                ? msg
                : msg.replace(/{([^{}]*)}/g, function (a, b) {
                    var replace = context[b];
                    return typeof replace === "string" || typeof replace === "number" ? replace : a;
                });
        });
        if (this.doAppendLogId) {
            msgs.push(" (ref: " + context._id + ")");
        }
        return msgs;
    };
    return Log;
}());
export default Log;
//# sourceMappingURL=Log.js.map